export const FOCUS_ACTION_LINE_EVENT = 'c2:focus-action-line';

export function requestActionLineFocus(): void {
  window.dispatchEvent(new CustomEvent(FOCUS_ACTION_LINE_EVENT));
}
